import { FC } from 'react'
import { Text } from '@saasalerts/ui'

export interface ILine {
  lines: Multiline[]
}

export type Multiline = {
  title: string | undefined
  size?: 'sm' | 'md'
  weight?: 'normal' | 'medium' | 'bold'
  color?: 'regular' | 'secondary'
}

export const MultiLineCell: FC<React.PropsWithChildren<ILine>> = ({
  lines,
}): React.ReactElement => {
  return (
    <div className="flex flex-col">
      {lines.map((line) => {
        return (
          line.title && (
            <Text
              as="div"
              key={line.title}
              size={line.size ?? 'md'}
              weight={line.weight ?? 'normal'}
              color={line.color ?? 'regular'}
            >
              {line.title}
            </Text>
          )
        )
      })}
    </div>
  )
}
